// update along with app/lib/enums/product_status.py
const ProductStatus = {
  UNCATEGORIZED: 0,
  CATEGORIZED: 1,
};

export const PRODUCT_STATUS_OPTIONS = [
  { value: ProductStatus.UNCATEGORIZED, label: 'Uncategorized' },
  { value: ProductStatus.CATEGORIZED, label: 'Categorized' },
];

export const SELECT_ALL_ON_PAGE = 'page_select';

export default ProductStatus;
